import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useLocation, useOutlet } from 'react-router-dom';

function PageContent({ children, pathname, reducedMotion, entering }) {
  useLayoutEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return <motion.div
    initial={!entering || reducedMotion ? false : { opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    exit={reducedMotion ? { opacity: 1 } : { opacity: 0, y: -6 }}
    transition={reducedMotion ? { duration: 0 } : { duration: 0.24, ease: [0.22, 1, 0.36, 1], opacity: { duration: 0.18 } }}
  >{children}</motion.div>;
}

export default function PageTransition() {
  const { pathname } = useLocation();
  const outlet = useOutlet();
  const mounted = useRef(false);
  useEffect(() => { mounted.current = true; }, []);
  const reducedMotion = useReducedMotion();
  return <AnimatePresence mode="wait" initial={false}>
    <PageContent key={pathname} pathname={pathname} entering={mounted.current} reducedMotion={reducedMotion}>{outlet}</PageContent>
  </AnimatePresence>;
}
